export default __webpack_public_path__ + "static/media/firasans-medium.832d9ab2.woff";